export function logSystem(log){
  const d = new Date();
  log = '[SYSTEM] '+log + ' ' + d.getHours() +':'+d.getMinutes()+':'+d.getSeconds();
  console.log(log);
}

export function logError(log){
  const d = new Date();
  const err = new Error();
  log = '[ERROR] '+log + ' ' + d.getHours() +':'+d.getMinutes()+':'+d.getSeconds()+err.stack;
  console.log(log);
}


// WEBPACK FOOTER //
// ./src/helpers/LogHelper.js